module.exports = __webpack_public_path__ + "media/aerial-farm-fullhd01.d28f8f0f.mp4";